var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"flex flex-col justify-center bg-o_purple-100 text-t_white text-lg py-7 pb-9 rounded-2xl"},_vm._l((_vm.footers),function(info){return _c('p',{key:info,staticClass:"mt-2 text-center"},[_vm._v(_vm._s(info))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }